import { PnlQueryRequest, PnlReportConfig } from 'src/components/star-grid/starGridTypes';
import { pnlQueryPayload } from 'src/components/star-grid/utils/pnlQueryRequest';

export const pnlSnapshotCacheKey = (reportId: number, request: PnlQueryRequest, definition?: PnlReportConfig): string =>
  JSON.stringify([
    reportId,
    definition?.source_mode,
    definition?.version,
    definition?.refreshed_at,
    definition?.mv_last_refresh_finished_time,
    {
      ...pnlQueryPayload(request),
      filters: Object.fromEntries(
        Object.entries(request.filters)
          .filter(([, values]) => values.length > 0)
          .sort(([left], [right]) => left.localeCompare(right))
          .map(([field, values]) => [field, [...new Set(values)].sort()])
      )
    }
  ]);
